import React, { useState, createRef } from 'react';
import PropTypes from 'prop-types';
import { Typography, FormHelperText, FormControl } from '@material-ui/core';
import Rating from 'react-rating';

const RatingSymbol = React.forwardRef(({ symbol, selected, onFocus, onBlur, text }, ref) => (
  <div
    ref={ref}
    onFocus={onFocus}
    onBlur={onBlur}
    tabIndex={selected ? -1 : 0}
    style={selected ? null : { filter: 'grayscale(100%)' }}
    title={text}
  >
    {symbol}
  </div>)
);

const FormIconRating = ({
  input,
  label,
  meta: { touched, error },
  values,
  disabled,
  symbol
}) => {
  const [focusedRatingIndex, setFocusedRatingIndex] = useState(-1);
  const ratingRefs = values.map(() => createRef());
  const handleKeyDown = e => {
    if (e.keyCode !== 32 && e.keyCode < 37 && e.keyCode < 40) return;
    if (e.keyCode === 32 && focusedRatingIndex > -1) {
      e.preventDefault();
      input.onChange(values[focusedRatingIndex].value);
    }
    else if ((e.keyCode === 37 || e.keyCode === 38) && focusedRatingIndex > 0) {
      e.preventDefault();
      ratingRefs[focusedRatingIndex - 1].current.focus();
    }
    else if ((e.keyCode === 39 || e.keyCode === 40) && focusedRatingIndex < values.length - 1) {
      e.preventDefault();
      ratingRefs[focusedRatingIndex + 1].current.focus();
    }
  };
  return (
    <FormControl component="fieldset" error={touched && error ? true : false}>
      {label && <Typography variant="caption" gutterBottom style={error ? { color: 'red' } : {}}>{label}</Typography>}
      <div onKeyDown={handleKeyDown}>
        <Rating
          fullSymbol={values.map(value => (<RatingSymbol key={value.name} symbol={symbol} selected text={value.name} />))}
          emptySymbol={values.map((value, i) => (<RatingSymbol
            ref={ratingRefs[i]}
            key={i}
            symbol={symbol}
            text={value.name}
            onBlur={() => setFocusedRatingIndex(-1)}
            onFocus={() => setFocusedRatingIndex(i)} />))}
          stop={values.length}
          initialRating={values.findIndex(item => item.value === input.value) + 1}
          onChange={value => input.onChange(values[value - 1].value)}
          readonly={disabled}
        />
        {input.value ? <FormHelperText>{values.find(v => v.value === input.value).name}</FormHelperText> : null}
        {touched && error ? <FormHelperText>{error}</FormHelperText> : null}
      </div>
    </FormControl>
  );
};

FormIconRating.propTypes = {
  input: PropTypes.object,
  label: PropTypes.string,
  meta: PropTypes.object,
  values: PropTypes.array.isRequired,
  symbol: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
};

export default FormIconRating;



// WEBPACK FOOTER //
// ./src/components/form/FormIconRating.js